import React, { useState } from "react";
import moment from "moment";
import fieldPropTypes from "./field-prop-types";
import renderFields from "../screens/render-fields";

const prepareChildrenToRender = data => {
  const bodyChildren = [
    {
      type: "htmlTextField",
      text: data.body,
      name: "message"
    }
  ];
  if (data.message_action_fields?.length) {
    bodyChildren.push({
      type: "callToActionButton",
      ...data.message_action_fields[0]
    });
  }
  return bodyChildren;
};

const buildBody = ({ data, components, appData, screen }) =>
  renderFields(prepareChildrenToRender(data), appData, components, screen);

const MessageDetailsView = ({
  field: { data },
  components,
  appData,
  screen
}) => {
  const [isExpanded, toggleExpansion] = useState(data.expanded || false);
  const updatedAt = isExpanded
    ? `${moment(data.updatedAt).format("hh:mm A")} GMT${moment(
        data.updatedAt
      ).format("Zz MM/DD/YY")}`
    : moment(data.updatedAt).format("MM/DD/YY");
  return (
    <components.ExpansionMessage
      expanded={isExpanded}
      title={data.senderName}
      updatedAt={updatedAt}
      shortDescription={data.body}
      body={buildBody({ data, components, appData, screen })}
      toggleExpansion={() => toggleExpansion(!isExpanded)}
    />
  );
};

MessageDetailsView.propTypes = fieldPropTypes;

export default MessageDetailsView;
